import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// components
import AlcoholPatientDataSidebar from '../../../components/alcohol/layout/patientDetailPage/AlcoholPatientDataSidebar';
import AlcoholPatientReport from '../../../components/alcohol/layout/patientDetailPage/AlcoholPatientReport';
import CommonModal from '../../../components/modal/CommonModal';

// api
import { getPatientFromAlcohol, getPatientProfileImageFromAlcohol, putPatientToAlcohol } from '../../../services/apis/alcohol/patient';
import { postMessageFromAlcohol } from '../../../services/apis/alcohol/message';

// 화면 표시용 마스킹 (원본 state / API 요청값은 마스킹하지 않는다)
function maskPhoneNumber(phoneNumber) {
	if (!phoneNumber) return '';
	const digits = String(phoneNumber).replace(/\D/g, '');
	if (digits.length >= 8) return `${digits.slice(0, 3)}-****-${digits.slice(-4)}`;
	return `${'*'.repeat(Math.max(digits.length - 4, 0))}${digits.slice(-4)}`;
}

function maskBirth(birth) {
	if (!birth) return '';
	return `${String(birth).slice(0, 4)}년 **월 **일`;
}

function AlcoholPatientManageDetailPage() {
	const navigate = useNavigate();
	const { pid } = useParams();

	const [patientData, setPatientData] = useState({
		psctId: "",
		name: "",
		age: "",
		sex: "",
		birth: "",
		phoneNumber: "",
		habitScore: 0,
		audit: "",
		rtcq: "",
		patientGroup: "",
		weekNum: 0,
		journaling: 0,
		doNotDrink: 0,
		sosCnt: 0,
		psctCode: ""
	})
	const [patientProfileImage, setPatientProfileImage] = useState("");
	
	// 환자 수정 Modal
	const [openModifyPatientModal, setOpenModifyPatientModal] = useState(false);
	const [openSendMessageModal, setOpenSendMessageModal] = useState(false);
	const [openAlertMessageModal, setOpenAlertMessageModal] = useState(false);

	const [patientDisplayName, setPatientDisplayName] = useState('');
	const [patientPhone1, setPatientPhone1] = useState('');
	const [patientPhone2, setPatientPhone2] = useState('');
	const [patientPhone3, setPatientPhone3] = useState('');
	const [patientBirthYear, setPatientBirthYear] = useState(new Date().getFullYear());
	const [patientBirthMonth, setPatientBirthMonth] = useState(new Date().getMonth() + 1);
	const [patientBirthDay, setPatientBirthDay] = useState(new Date().getDate());
	const [patientDoctorCode, setPatientDoctorCode] = useState('');
	const [patientGender, setPatientGender] = useState('');
	const [patientGroup, setPatientGroup] = useState('');

	const [message, setMessage] = useState("");

	// 환자 정보 조회 
	async function getPatienDataFromAPI() {
		try{
			const request = { pid };
			const res = await getPatientFromAlcohol(request);
			if(parseInt(res.status/200,10)===1){
				const originalData = res.data[0];
				const newPatientData = {
					psctId: originalData.psctId || "",
					name:  originalData.name || "",
					age: originalData.age || "",
					sex: originalData.sex || "",
					birth: originalData.birth || "",
					phoneNumber: originalData.phoneNumber || "",
					habitScore: originalData.habitScore || 0,
					audit: originalData.audit || "",
					rtcq: originalData.rtcq || "",
					patientGroup: originalData.patientGroup || "",
					weekNum: originalData.weekNum || 0,
					journaling: originalData.journaling || 0,
					doNotDrink: originalData.doNotDrink || 0,
					sosCnt: originalData.sosCnt || 0,
					psctCode: originalData.psctCode
				}
				setPatientData(newPatientData);
			}else{
				alert('환자 정보가 존재하지 않습니다.');
				navigate('/dtx001/patient-manage/list');
			}
		}catch(err){
			console.error(err);
			alert('환자 정보가 존재하지 않습니다.');
			navigate('/dtx001/patient-manage/list');
		}
	}

	// 환자 프로필 이미지 조회
	async function getPatientProfileImageFromAPI() {
		try {
			const request = { pid };
			const res = await getPatientProfileImageFromAlcohol(request);
			if(parseInt(res.status/200,10)===1){
                const imgURL = URL.createObjectURL(res.data);
				setPatientProfileImage(imgURL || "")
			}
		}catch(err){
			console.error(err);
		}
	}


	// 수정 모달 ----------------------------

	function initializeModifyModal(initialData) {
		setPatientDisplayName(initialData.name || "");const phone = initialData.phoneNumber ? initialData.phoneNumber.replace(/\D/g, '') : "";
		// 전화번호 패턴: 지역번호는 02 또는 3자리, 그 뒤 3~4자리, 마지막 4자리
		const regex = /^(02|\d{3})(\d{3,4})(\d{4})$/;
		const phoneMatch = phone.match(regex);
		
		if (phoneMatch) {
		  setPatientPhone1(phoneMatch[1]);
		  setPatientPhone2(phoneMatch[2]);
		  setPatientPhone3(phoneMatch[3]);
		} else {
		  // 전화번호 형식이 맞지 않으면 기본값 설정 또는 예외 처리
		  setPatientPhone1("");
		  setPatientPhone2("");
		  setPatientPhone3("");
		}
		setPatientBirthYear(Number(initialData.birth ? initialData.birth.slice(0,4) : new Date().getFullYear() ));
		setPatientBirthMonth(Number(initialData.birth ? initialData.birth.slice(4,6) : new Date().getMonth() + 1));
		setPatientBirthDay(Number(initialData.birth ? initialData.birth.slice(6,8) : new Date().getDate()));
		setPatientDoctorCode(initialData.psctCode || "");
		setPatientGender(initialData.sex || "");
		setPatientGroup(initialData.patientGroup || "");
	}

	const showModifyPatientModal = () => {
		setOpenModifyPatientModal(true);
	}

	const closeModifyPatientModal = () => {
		setOpenModifyPatientModal(false);
		initializeModifyModal(patientData);
	}

	const selectYear = () => {
		const yearItems = [];
		for (let year = 1900; year <= new Date().getFullYear(); year++) {
			yearItems.push(
				<option key={year} value={year}>
					{year}
				</option>,
			);
		}
		return yearItems;
	};
	
	const selectMonth = () => {
		const monthItems = [];
		const currentDate = new Date();
		const currentYear = currentDate.getFullYear();
		const currentMonth = currentDate.getMonth() + 1; // JS의 month는 0부터 시작
		let maxMonth = 12;
		const selectedYear = parseInt(patientBirthYear, 10);
		// 만약 선택된 연도가 현재 연도라면 현재 달까지만 선택할 수 있음
		if (selectedYear === currentYear) {
		  maxMonth = currentMonth;
		}
		for (let month = 1; month <= maxMonth; month++) {
		  monthItems.push(
			<option key={month} value={month}>
			  {month}
			</option>
		  );
		}
		return monthItems;
	  };
	  
	  const selectDay = () => {
		const dayItems = [];
		const currentDate = new Date();
		const currentYear = currentDate.getFullYear();
		const currentMonth = currentDate.getMonth() + 1;
		const currentDay = currentDate.getDate();
		
		const selectedYear = parseInt(patientBirthYear, 10);
		const selectedMonth = parseInt(patientBirthMonth, 10);
		
		let maxDay = 31;
		if (selectedYear && selectedMonth) {
		  // 해당 월의 마지막 날짜를 구함
		  maxDay = new Date(selectedYear, selectedMonth, 0).getDate();
		  // 선택한 연도와 월이 현재와 동일하면 현재 날짜까지만 선택 가능
		  if (selectedYear === currentYear && selectedMonth === currentMonth) {
			maxDay = currentDay;
		  }
		}
		for (let day = 1; day <= maxDay; day++) {
		  dayItems.push(
			<option key={day} value={day}>
			  {day}
			</option>
		  );
		}
		return dayItems;
	  };
	  

	const calculateAge = (birthYear, birthMonth, birthDay) => {
		// 전달된 인자를 숫자로 변환합니다.
		const year = parseInt(birthYear, 10);
		const month = parseInt(birthMonth, 10);
		const day = parseInt(birthDay, 10);
		
		// 현재 날짜 정보를 가져옵니다.
		const currentDate = new Date();
		const currentYear = currentDate.getFullYear();
		const currentMonth = currentDate.getMonth() + 1; // 0부터 시작하므로 +1
		const currentDay = currentDate.getDate();
		
		// 기본 만 나이를 계산합니다.
		let age = currentYear - year;
		
		// 생일이 아직 지나지 않았다면 나이를 1감소시킵니다.
		if (currentMonth < month 
			|| (currentMonth === month && currentDay < day)) {
		  age--;
		}

		if (age < 0) {
			age = 0;
		}
		
		return age;
	  };
	  

// psctCode: patientDoctorCode,
	async function modifyPatient() {
		try{
			const request = {
				psctId: patientData.psctId,
				name: patientDisplayName,
				phoneNumber: `${patientPhone1}${patientPhone2}${patientPhone3}`,		
				sex: patientGender,
				psctCode: patientDoctorCode,
				birth:
					patientBirthYear.toString() +
					patientBirthMonth.toString().padStart(2, 0) +
					patientBirthDay.toString().padStart(2, 0),
				patientGroup
			};
			const res = await putPatientToAlcohol(request);
			if(parseInt(res.status/200,10)===1 && res.data==="OK"){
				getPatienDataFromAPI();
				closeModifyPatientModal();
			}else{
				alert("환자 수정에 실패하였습니다.");
			}
		}catch(err){
			console.error(err);
			alert("환자 수정에 실패하였습니다.");
		}
	}

	function disableModifyModal () {
		if(patientDisplayName && patientPhone1 && patientPhone2 && patientPhone3 && patientBirthYear && patientBirthMonth && patientBirthDay && patientDoctorCode && patientGender && patientGroup) {
			return false;
		}
		
		return true
	}

	const ModifyPatientModalBody = (
		<div className="modalbody">
			<div className="formModalItem">
				<div className="formModalItem__label">이름</div>
				<div className="formModalItem__input">
					<input
						type="text"
						className="formModalItem__input__plainText"
						placeholder="이름"
						value={patientDisplayName}
						onChange={e => setPatientDisplayName(e.target.value)}
					/>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">전화번호</div>
				<div className="formModalItem__input">
					<input
						type="text"
  						pattern="\d*"
  						inputMode="numeric"
						className="formModalItem__input__phoneNumber"
						value={patientPhone1}
						onChange={e => {
							// 숫자만 허용 (빈 문자열 포함)
							if (/^\d*$/.test(e.target.value)) {
							  setPatientPhone1(e.target.value);
							}
						}}
  						onKeyDown={e => {
    						 // 허용할 키 목록
    const allowedKeys = [
		'Backspace',
		'Delete',
		'ArrowLeft',
		'ArrowRight',
		'Tab',
		// 필요시 Home, End 등 추가 가능
	  ];
	  // e.key가 한 글자(숫자)이면 정규식을 사용하여 확인
	  if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
		e.preventDefault();
	  }
	}}
						  onPaste={e => {
							// 붙여넣기 이벤트 처리: 붙여넣은 값이 숫자만 포함된 경우에만 적용
							e.preventDefault();
							const pasteData = e.clipboardData.getData('text');
							if (/^\d*$/.test(pasteData)) {
							  setPatientPhone1(pasteData);
							}
						  }}
						size={3}
						maxLength={3}
						placeholder= {patientPhone1}
					/>
					<span className="phoneDivider">-</span>
					<input
						type="text"
  						pattern="\d*"
  						inputMode="numeric"
						className="formModalItem__input__phoneNumber"
						value={patientPhone2}
						onChange={e => {
							if (/^\d*$/.test(e.target.value)) {
								setPatientPhone2(e.target.value);
							}
						}}
						onKeyDown={e => {
    						 // 허용할 키 목록
    const allowedKeys = [
		'Backspace',
		'Delete',
		'ArrowLeft',
		'ArrowRight',
		'Tab',
		// 필요시 Home, End 등 추가 가능
	  ];
	  // e.key가 한 글자(숫자)이면 정규식을 사용하여 확인
	  if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
		e.preventDefault();
	  }
	}}
						  onPaste={e => {
							// 붙여넣기 이벤트 처리: 붙여넣은 값이 숫자만 포함된 경우에만 적용
							e.preventDefault();
							const pasteData = e.clipboardData.getData('text');
							if (/^\d*$/.test(pasteData)) {
								setPatientPhone2(pasteData);
							}
						  }}
						size={4}
						maxLength={4}
						placeholder={patientPhone2}
					/>
					<span className="phoneDivider">-</span>
					<input
						type="text"
  						pattern="\d*"
  						inputMode="numeric"
						className="formModalItem__input__phoneNumber"
						value={patientPhone3}
						onChange={e => {
							if (/^\d*$/.test(e.target.value)) {
								setPatientPhone3(e.target.value);
							}
						}}
						onKeyDown={e => {
    						 // 허용할 키 목록
    const allowedKeys = [
		'Backspace',
		'Delete',
		'ArrowLeft',
		'ArrowRight',
		'Tab',
		// 필요시 Home, End 등 추가 가능
	  ];
	  // e.key가 한 글자(숫자)이면 정규식을 사용하여 확인
	  if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
		e.preventDefault();
	  }
	}}
						  onPaste={e => {
							// 붙여넣기 이벤트 처리: 붙여넣은 값이 숫자만 포함된 경우에만 적용
							e.preventDefault();
							const pasteData = e.clipboardData.getData('text');
							if (/^\d*$/.test(pasteData)) {
								setPatientPhone3(pasteData);
							}
						  }}
						size={4}
						maxLength={4}
						placeholder={patientPhone3}
					/>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label_large">의료진 코드</div>
				<div className="formModalItem__input">
					<input
						type="text"
						className="formModalItem__input__plainTextWithButton"
						placeholder="의료진 코드"
						value={patientDoctorCode}
						onChange={e => setPatientDoctorCode(e.target.value)}
						disabled
					/>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">성별</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="male"
							value="M"
							name="gender"
							checked={patientGender === 'M'}
							onChange={e => setPatientGender(e.target.value)}
						/>{' '}
						<label htmlFor="male" className="formModalItem__input__radioLabel">
							남성
						</label>
					</div>
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="female"
							value="F"
							name="gender"
							checked={patientGender === 'F'}
							onChange={e => setPatientGender(e.target.value)}
						/>{' '}
						<label htmlFor="female" className="formModalItem__input__radioLabel">
							여성
						</label>
					</div>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">생년월일</div>
				<div className="formModalItem__input">
					<select
						className="formModalItem__input__birth"
						onChange={e => setPatientBirthYear(e.target.selectedOptions[0].value)}
						value={patientBirthYear}
					>
						{selectYear()}
					</select>
					<span className="birthText">년</span>
					<select
						className="formModalItem__input__birth"
						onChange={e => setPatientBirthMonth(e.target.selectedOptions[0].value)}
						value={patientBirthMonth}
					>
						{selectMonth()}
					</select>
					<span className="birthText">월</span>
					<select
						className="formModalItem__input__birth"
						onChange={e => setPatientBirthDay(e.target.selectedOptions[0].value)}
						value={patientBirthDay}
					>
						{selectDay()}
					</select>
					<span className="birthText">일</span>
					<div className="formModalItem__input__age">만 {calculateAge(patientBirthYear, patientBirthMonth, patientBirthDay)}세</div>
				</div>
			</div>			
			<div className="formModalItem">
				<div className="formModalItem__label_large">환자군</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="실험군"
							value="exp"
							name="patient-group"
							checked={patientGroup === 'exp'}
							onChange={e => setPatientGroup(e.target.value)}
						/>{' '}
						<label htmlFor="실험군" className="formModalItem__input__radioLabel">
							실험군
						</label>
					</div>
				</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="대조군"
							value="comp"
							name="patient-group"
							checked={patientGroup === 'comp'}
							onChange={e => setPatientGroup(e.target.value)}
						/>{' '}
						<label htmlFor="대조군" className="formModalItem__input__radioLabel">
						대조군
						</label>
					</div>
				</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="테스트"
							value="tester"
							name="patient-type"
							checked={patientGroup === 'tester'}
							onChange={e => setPatientGroup(e.target.value)}
						/>{' '}
						<label htmlFor="테스트" className="formModalItem__input__radioLabel">
							테스트
						</label>
					</div>
				</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="일반"
							value="common"
							name="patient-type"
							checked={patientGroup === 'common'}
							onChange={e => setPatientGroup(e.target.value)}
						/>{' '}
						<label htmlFor="일반" className="formModalItem__input__radioLabel">
							일반
						</label>
					</div>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label_large">환자 타입</div>
				<div>
					<div className='formModalItem_subItem_patient_detail'>
						<div className="formModalItem__subItem_label">문제성 음주</div>
						<div className="formModalItem__input">
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
								<input
									type="radio"
									id="High"
									value="High"
									name="patient-type-problem"
									checked={patientData.audit === 'High'}
									disabled
								/>{' '}
								<label htmlFor="High" className="formModalItem__input__radioLabel">
									High
								</label>
							</div>
						</div>
						<div className="formModalItem__input">
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
								<input
									type="radio"
									id="Low"
									value="Low"
									name="patient-type-problem"
									checked={patientData.audit === 'Low'}
									disabled
								/>{' '}
								<label htmlFor="Low" className="formModalItem__input__radioLabel">
									Low
								</label>
							</div>
						</div>
					</div>
					<div className='formModalItem_subItem_patient_detail'>
						<div className="formModalItem__subItem_label">변화 준비</div>
						<div className="formModalItem__input">
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
								<input
									type="radio"
									id="Ready"
									value="Ready"
									name="patient-type-ready"
									checked={patientData.rtcq === 'Ready'}
									disabled
								/>{' '}
								<label htmlFor="Ready" className="formModalItem__input__radioLabel">
									Ready
								</label>
							</div>
						</div>
						<div className="formModalItem__input">
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
								<input
									type="radio"
									id="No"
									value="No"
									name="patient-type-ready"
									checked={patientData.rtcq === 'No'}
									disabled
								/>{' '}
								<label htmlFor="No" className="formModalItem__input__radioLabel">
									No
								</label>
							</div>
						</div>
					</div>
				</div>				
			</div>
		</div>
	);

	const ModifyPatientModalFooter = (
		<div className="modalfooter">
			<button className="submitButton__rounded" onClick={modifyPatient} disabled={disableModifyModal()}>
				저장
			</button>
			<button className="cancelButton__rounded" onClick={closeModifyPatientModal}>
				취소
			</button>
		</div>
	);

	// 메시지 모달 ----------------------------
	const showSendMessageModal = () => {
		setOpenSendMessageModal(true);
	}

	const closeSendMessageModal = () => {
		setOpenSendMessageModal(false);
		setMessage("");
	}

	const SendMessageModalBody = (
		<div className="modalbody">
			<div className="formModalItem">
				<div className="formModalItem__label">내용</div>
				<div className="formModalItem__input">
					<textarea
						type="text"
  						maxLength={300}
						className="formModalItem__input__textarea"
						placeholder="메시지 내용을 입력해주세요. (최대 300자)"
						value={message}
						onChange={e => setMessage(e.target.value)}
						style={{ height: '21.875rem' }}
					/>
				</div>
			</div>
			<div>{message.length} / 300</div>
		</div>
	)

	async function sendMessage () {
		if(!message) return;

		try{
			const request = {
				pid,
				name: patientData.name || "",
				message
			}
			const res = await postMessageFromAlcohol(request);
			if(parseInt(res.status/200,10)===1){
				closeSendMessageModal();
			}else{
				alert("메시지 전송에 실패하였습니다.");
			}
		}catch(err){
			console.error(err);
			alert("메시지 전송에 실패하였습니다.");
		}
	} 

	const SendMessageModalFooter = (
		<div className="modalfooter">
			<button className="submitButton__rounded" onClick={sendMessage} disabled={!message}>
				전송
			</button>
			<button className="cancelButton__rounded" onClick={closeSendMessageModal}>
				취소
			</button>
		</div>
	);

	// 메시지 Alert 모달 ------------------------------

	const closeAlertMessageModal = () => {
		setOpenAlertMessageModal(false);
	}

	const AlertMessageModalBody = (
		<div className="modalbody">
			<div className="formModalItem">
				<div className='formModalItem_text'>전송할 내용을 입력해주세요.</div>
			</div>
		</div>
	)

	const AlertMessageModalFooter = (
		<div className="modalfooter">
			<button className="submitButton__rounded w-100" onClick={closeAlertMessageModal}>
				확인
			</button>
		</div>
	)

	useEffect(()=>{
		getPatienDataFromAPI();
		getPatientProfileImageFromAPI();
	},[])


	useEffect(()=>{
		initializeModifyModal(patientData);
	},[patientData])

	return (
		<div className="dashboardContent">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">환자 관리 {'>'} 환자 상세 페이지</span>
			</div>
			<div className="dashboardContent__inner">
				<div className="patientManageDetail">
					<AlcoholPatientDataSidebar
						patientData={patientData}
						birthDisplay={maskBirth(patientData.birth)}
						phoneDisplay={maskPhoneNumber(patientData.phoneNumber)}
						patientProfileImage={patientProfileImage}
						showModifyPatientModal={showModifyPatientModal}
						showSendMessageModal={showSendMessageModal}
					/>
					<AlcoholPatientReport patientData={patientData} />
				</div>
			</div>
			<CommonModal
				header="메시지 전송하기"
				body={SendMessageModalBody}
				footer={SendMessageModalFooter}
				show={openSendMessageModal}
				setClose={closeSendMessageModal}
				size="lg"
			/>
			<CommonModal
				header="환자 수정"
				body={ModifyPatientModalBody}
				footer={ModifyPatientModalFooter}
				show={openModifyPatientModal}
				setClose={closeModifyPatientModal}
				size="lg"
			/>
			<CommonModal
				header="메시지 전송하기"
				body={AlertMessageModalBody}
				footer={AlertMessageModalFooter}
				show={openAlertMessageModal}
				setClose={closeAlertMessageModal}
				size="sm"
			/>
		</div>
	);
}

export default AlcoholPatientManageDetailPage;
